import _ from 'lodash'
import { useEffectOnce } from 'react-use'
import { useLocation } from 'react-router-dom'
import { mealIngredientListPromise } from 'api/MealIngredient'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import MealIngredientTable from './components/MealIngredientListTable'
import MealIngredientToolbar from './components/MealIngredientListToolbar'

const MealIngredientList = props => {
  const ref = useRef()
  const location = useLocation()
  const [ingredients, setIngredients] = useState({})
  const [params, setParams] = useState({ page: 1 })

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    mealIngredientListPromise(too).then(resp => setIngredients(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  function handleSearchChange (payload) {
    handleParamsChange(payload, 500)
  }
  // end
  
  return (
    <div className={'root'}>
      <div className={'content'}>
        <MealIngredientToolbar {...props} params={params} handleSearchChange={handleSearchChange} />
        <br />
        <MealIngredientTable {...props} page={params.page} data={ingredients} onPageChange={handlePageChange} />
      </div>
    </div>
  )
}

export default MealIngredientList